
/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */


import * as Utils from '@Cyclope-Utils/index';
import {GetZoneByIdCameraLoadedActionFail, GetZoneByIdCameraLoadedActionInProgress, GetZoneByIdCameraLoadedActionSuccess} from '@tunnel-store/index';
import {Dispatch} from 'redux';

/**
 * @function GetZoneByIdCameraLoadedActionCreator
 * @param { number } cameraId
 * @param { number } zoneId
 * @return {Promise<any>}  Promise
 */

export function MaskZoneLoadedActionCreator(cameraId: number, zoneId: number): (
    dispatch: Dispatch<any>, {}) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    dispatch(GetZoneByIdCameraLoadedActionInProgress());
    if (zoneId !== null) {
            await Utils.fetchTunnelWatchZonemaskByCameraId(cameraId,zoneId)
            .then((response: any)=> {
        if (response.ok) {
          /**
           * @constant
           * @name contentHeader
           * @type string
           */
          const contentHeader: string = response.headers.get('content-type');
          { /* Comparer les valeurs */
          }
          if (contentHeader && contentHeader !== null &&
              contentHeader.indexOf('image/png') !== -1) {
            if (response.status === 200) {
              { /** Renvoie une promise qui retourne le résultat en JSON  */
              }
              response.blob().then((data: any) => {
                const objectURL = URL.createObjectURL(data);
                dispatch(GetZoneByIdCameraLoadedActionSuccess(objectURL));
              });  // État du state : resultat final
            }
            if (response.status === 203) {
              { /** Renvoie une promise qui retourne le résultat undefined */
              }
              response.json().then(
                  (text: any) => dispatch(GetZoneByIdCameraLoadedActionSuccess(
                      [])))  // État du state : resultat final
            }
          }
          if (contentHeader === null || contentHeader === undefined) {
            if (response.status === 203) {
              { /** Renvoie une promise qui retourne le résultat undefined */
              }
              response.text().then(
                  (text: any) => dispatch(GetZoneByIdCameraLoadedActionSuccess(
                      [])))  // État du state : resultat final
            }
          }
        } else {
          throw ({
            message: response.statusText,
            status: response.status,
            url: response.url,
            headers: response.headers
          });
        }}).catch( (error: any) => {
                    dispatch(GetZoneByIdCameraLoadedActionFail(error.status + ' -- ' + Math.random())) /* { // État du state : échec  }*/
                    Utils.fetchLogs(error.url,error.message,error.status,error.headers)
                })
    }


    /*
        .then((res: any) => {
            if( res.ok ){ res.blob().then( (blob: any) =>
    dispatch(GetZoneByIdCameraLoadedActionSuccess(URL.createObjectURL(blob))))
            }else{
                throw Error(res.statusText +", server status:"+ res.status);
            }
        })
        .catch( (error : any) =>
    dispatch(GetZoneByIdCameraLoadedActionFail(error.message +" ,random value:"+
    Math.random())))
    }*/
  }
}



// WEBPACK FOOTER //
// ./src/apps/tunnel/store/actionsCreator/actions/maskbyzone/index.ts